import React from 'react';

import { formatDate } from 'helpers/formatDate';

import { Loading } from 'components/shared/Loading';
import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';
import { Table } from 'components/shared/Table';

import { MenuLayout } from 'components/Layout';
import { EmptyState } from 'components/EmptyState';
import { ListToolbar } from 'components/Toolbar';
import { PublishStatusTag } from 'components/PublishStatusTag';

import { columns } from './CatalogLessonsPage.tableConfig';

import styles from './CatalogLessonsPage.module.scss';

const cellRenderer = (
  {
    item,
    key,
    minWidth,
    maxWidth,
  }: { item: any; key: any; minWidth: any; maxWidth: any },
  DefaultCell: any,
) => {
  switch (key) {
    case 'status': {
      const status = item[key];

      return (
        <div
          className={styles.statusCell}
          key={key}
          style={{ minWidth, maxWidth }}
        >
          {status ? (
            <PublishStatusTag variant={status.toLowerCase()} />
          ) : (
            '-'
          )}
        </div>
      );
    }
    case 'createdAt': {
      return (
        <DefaultCell key={key} style={{ minWidth, maxWidth }}>
          {formatDate(item[key], 'dd MMM, yyyy')}
        </DefaultCell>
      );
    }
    default: {
      return (
        <DefaultCell key={key} minWidth={minWidth} maxWidth={maxWidth}>
          {item[key] || '-'}
        </DefaultCell>
      );
    }
  }
};

const CatalogLessonsPage = ({
  loading,
  lessons,
  onLessonRowClick,
  onLessonCreateClick,
  onLessonRemoveClick,
  onLessonEditClick,
}: {
  loading: any;
  lessons: any;
  onLessonRowClick: any;
  onLessonCreateClick: any;
  onLessonRemoveClick: any;
  onLessonEditClick: any;
}) => {
  return (
    <MenuLayout>
      <ListToolbar
        title="Lessons"
        actionComponent={
          <Button
            size="md"
            variant="link"
            startIcon={<Icon name="plusRound" />}
            onClick={onLessonCreateClick}
          >
            Create lesson
          </Button>
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          {lessons.length ? (
            <div className={styles.inner}>
              <Table
                columns={columns}
                actions={[
                  {
                    key: 'edit',
                    icon: 'edit',
                    tooltipText: 'Edit lesson',
                    onClick: onLessonEditClick,
                  },
                  {
                    key: 'remove',
                    icon: 'trash',
                    tooltipText: 'Remove lesson',
                    onClick: onLessonRemoveClick,
                  },
                ]}
                data={lessons}
                cellRenderer={(props: any, DefaultCell: any) =>
                  cellRenderer(props, DefaultCell)
                }
                onRowClick={(lesson: any) => onLessonRowClick(lesson.id)}
              />
            </div>
          ) : (
            <EmptyState
              className={styles.emptyState}
              icon="lessons"
              title="Add a lesson"
              text="No lessons - yet! Looks like you haven't created a lesson. Add a new lesson in the top right corner"
            />
          )}
        </>
      )}
    </MenuLayout>
  );
};

export default React.memo(CatalogLessonsPage) as any;
